// extracted by mini-css-extract-plugin
module.exports = {"loading":"FullpageLoading_loading__3f-nq","text":"FullpageLoading_text__fLYTc","spinner":"FullpageLoading_spinner__1X5qx"};